export function suggestCategoryCode(name, existingCodes = []) {
  const words = name
    .toUpperCase()
    .replace(/[.,/()\\&+-]/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .split(" ")
    .filter((w) => w.length > 0);

  if (words.length === 0) return "";

  const inUse = (code) =>
    existingCodes.some((c) => c.toUpperCase() === code.toUpperCase());

  const c1 =
    words.length === 1
      ? words[0].slice(0, 2)
      : words.map((w) => w[0]).join("").slice(0, 4);

  if (!inUse(c1)) return c1;

  const c2 = (words[0].slice(0, 2) + words.slice(1).map((w) => w[0]).join("")).slice(0, 4);
  if (!inUse(c2)) return c2;

  for (let n = 2; ; n++) {
    const candidate = c1 + n;
    if (!inUse(candidate)) return candidate;
  }
}

export function validateCategoryCode(code, existingCodes = []) {
  const norm = code.trim().toUpperCase();
  if (!norm) return "Kode kategori wajib diisi.";
  if (!/^[A-Z0-9]+$/.test(norm)) return "Kode hanya boleh huruf/angka.";
  if (norm.length > 5) return "Kode maksimal 5 karakter.";
  if (existingCodes.some((c) => c.toUpperCase() === norm))
    return "Kode ini sudah dipakai kategori lain.";
  return null;
}
